enum ButtonName {
  AuctionsTab = "AuctionsTab",
  NotificationsTab = "NotificationsTab",
  OffersTab = "OffersTab",
}

export default ButtonName;
